import React from 'react'
import SubscriptionFailureDetails from '../../components/User/SubscriptionFailure';

const SubscriptionFailure = () => {
  return (
    <SubscriptionFailureDetails />
  )
}

export default SubscriptionFailure;